/* eslint-disable */
import sessionManager from '../auth/session/sessionManager'
import routeGuard from '../routing/routeGuard'
import Logger from "../logger/logger";

var logger = Logger.getLogger("LEFramework");
function isBasePath(path) {
  return !!path && path.startsWith(`/${this.__base || ''}`);
}

function beforeFirst(callback) {
  function before(to, from, next) {
    if (typeof callback === 'function' && !this.__firstVisit) {
      this.__firstVisit = true;
      callback(to, from, next);
    } else {
      next();
    }
  }

  this.beforeEach(before.bind(this));
}

function beforeEachBase(callback) {
  function before(to, from, next) {
    if (typeof callback === 'function' && this.isBasePath(to.path)) {
      callback(to, from, next);
      const validationInfo = routeGuard.validateRoutePermissions(to, from, !sessionManager.hasProfilesFeature());
      if (validationInfo.auth.valid === true) {
        // if first route to LE vue router not active and need to trigger first route
        return next();
      }
      else {
        if (validationInfo.auth && validationInfo.auth.unauthorizedRouteRedirect) {
          return next(validationInfo.auth.unauthorizedRouteRedirect);
        }
        return next(false);
      }
    } else {
      next();
    }
  }
  this.beforeEach(before.bind(this));
}

function beforeFirstBase(callback) {
  function before(to, from, next) {
    if (typeof callback === 'function' && !this.__firstBaseVisit && this.isBasePath(to.path)) {
      this.__firstBaseVisit = true;
      callback(to, from, next);
    } else {
      next();
    }
  }

  this.beforeEach(before.bind(this));
}

function proxyAddRoutes(router) {
  const baseAddRoutes = router.addRoutes;

  return function addRoutes(routes) {
    const parsed = [];
    if (routes) {
      routes.forEach((route) => {
        parsed.push(Object.assign({}, route, {
          path: `${this.__base || ''}${route.path}`,
        }));
      });

      baseAddRoutes.call(this, parsed);
    }
  };
}

const extendRouter = (router, base, hooks) => {
  const __base = base || '';
  Object.assign(router, {
    __base,
    addRoutes: proxyAddRoutes(router),
    isBasePath,
    beforeFirst,
    beforeEachBase,
    beforeFirstBase,
  });

  if (hooks) {
    Object.keys(hooks).forEach((hook) => {
      if (typeof router[hook] === 'function') {
        router[hook](hooks[hook]);
      }
    });
  }

  return router
};

class BaseVueRouter {
  constructor(VueRouter, base, options, hooks) {
    const routes = [];
    let config = {};

    if (options && options.routes) {

      options.routes.forEach((route) => {
        routes.push(Object.assign({}, route, {
          path: `/${base || ''}${route.path}`,
        }));
      });

      config = Object.assign({}, options, {
        routes,
      });
    }

    const router = new VueRouter(config);
    extendRouter(router, base, hooks);

    return router;
  }
}

export default BaseVueRouter;



// WEBPACK FOOTER //
// ./src/base/BaseVueRouter.js